import { useEffect } from 'react';

const useScriptInvoked = (url: string | null, checkExists = true): void => {
  useEffect(() => {
    let script: HTMLScriptElement | undefined;

    if (url && (checkExists ? !document.querySelector(`script[src="${url}"]`) : true)) {
      script = document.createElement('script');

      script.src = url;
      script.async = true;

      document.body.appendChild(script);
    }

    return () => {
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, [checkExists, url]);
};

export default useScriptInvoked;
